
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  i18nComponentKey: 'WidgetReviewsBoardMobile',
  name: 'WidgetReviewsBoardMobile',
  mixins: [PaginatedReviewResourceView],
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('widget', [
      'headerSectionShowable',
      'showFilterSection',
      'appHeaderV2AndTitleShowable'
    ]),
    defaultResourceParams() {
      return {
        fields: 'has_media'
      };
    },
    contentsStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    }
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup']),
    submit(params) {
      this.searchResource(params);
    }
  }
};
